import React, { useState } from "react";
import { Link } from "react-router-dom";

import "./../Styles/sidebar.css";
import "./../Styles/userheader.css";
import "./../Styles/Dashboard.css";
import "./../Styles/Addmachine.css";
import "./../Styles/viewmachine.css";
import "./../Styles/Viewdesigner.css";

const closeSidebarMobile = () => {
  if (window.innerWidth <= 768) {
    document.body.classList.remove("sidebar-open");
  }
};

export default function Sidebar() {
  const [machineOpen, setMachineOpen] = useState(false);
  const [designerOpen, setDesignerOpen] = useState(false);
  const [workspaceOpen, setWorkspaceOpen] = useState(false);
  const [designOpen, setDesignOpen] = useState(false);

  return (
    <div className="us-container">
      {/* Overlay */}

      <div className="us-sidebar">
        <h2 className="us-logo">Admin Panel</h2>

        <ul className="us-menu">
          {/* Dashboard */}

          <li>
            <Link
              to="/admin/dashboard"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-speedometer2"></i>
              <span>Dashboard</span>
            </Link>
          </li>

          {/* Machines */}

          <li>
            <div
              className="us-menu-title"
              onClick={() => setMachineOpen(!machineOpen)}
            >
              <div className="us-menu-left">
                <i className="bi bi-gear"></i>
                <span>Manage Machines</span>
              </div>

              <i
                className={`bi ${machineOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            {machineOpen && (
              <ul className="us-submenu">
                <li>
                  <Link to="/admin/add-machine" onClick={closeSidebarMobile}>
                    Add Machine
                  </Link>
                </li>

                <li>
                  <Link to="/admin/view-machine" onClick={closeSidebarMobile}>
                    Active Machines
                  </Link>
                </li>

                <li>
                  <Link
                    to="/admin/pending-machine"
                    onClick={closeSidebarMobile}
                  >
                    Pending Approval
                  </Link>
                </li>

                <li>
                  <Link to="/admin/hide-machine" onClick={closeSidebarMobile}>
                    Hide Machines
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Designers */}

          <li>
            <div
              className="us-menu-title"
              onClick={() => setDesignerOpen(!designerOpen)}
            >
              <div className="us-menu-left">
                <i className="bi bi-palette"></i>
                <span>Manage Designers</span>
              </div>

              <i
                className={`bi ${designerOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            {designerOpen && (
              <ul className="us-submenu">
                <li>
                  <Link to="/admin/add-designer" onClick={closeSidebarMobile}>
                    Add Designer
                  </Link>
                </li>

                <li>
                  <Link to="/admin/view-designer" onClick={closeSidebarMobile}>
                    Active Designers
                  </Link>
                </li>

                <li>
                  <Link
                    to="/admin/pending-designer"
                    onClick={closeSidebarMobile}
                  >
                    Pending Approval
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Workspace */}

          <li>
            <div
              className="us-menu-title"
              onClick={() => setWorkspaceOpen(!workspaceOpen)}
            >
              <div className="us-menu-left">
                <i className="bi bi-building"></i>
                <span>Manage Workspace</span>
              </div>

              <i
                className={`bi ${workspaceOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            {workspaceOpen && (
              <ul className="us-submenu">
                <li>
                  <Link to="/admin/add-workspace" onClick={closeSidebarMobile}>
                    Add Workspace
                  </Link>
                </li>

                <li>
                  <Link to="/admin/view-workspace" onClick={closeSidebarMobile}>
                    Active Workspace
                  </Link>
                </li>

                <li>
                  <Link
                    to="/admin/pending-workspace"
                    onClick={closeSidebarMobile}
                  >
                    Pending Approval
                  </Link>
                </li>
                <li>
                  <Link to="/admin/hide-workspace" onClick={closeSidebarMobile}>
                    Hide Workspace
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li>
            <Link
              to="/admin/ads-plan"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-bag"></i>
              <span>Ads Manager</span>
            </Link>
          </li>

          {/* Designs */}

          <li>
            <div
              className="us-menu-title"
              onClick={() => setDesignOpen(!designOpen)}
            >
              <div className="us-menu-left">
                <i className="bi bi-grid"></i>
                <span>Designs</span>
              </div>

              <i
                className={`bi ${designOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            {designOpen && (
              <ul className="us-submenu">
                <li>
                  <Link to="/admin/add-design" onClick={closeSidebarMobile}>
                    Add Design
                  </Link>
                </li>

                {/* <li>
<Link to="/admin/view-design" onClick={closeSidebarMobile}>
View Design
</Link>
</li> */}
              </ul>
            )}
          </li>

          {/* Orders */}

          <li>
            <Link
              to="/admin/orders"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-bag"></i>
              <span>Orders</span>
            </Link>
          </li>

          {/* Users */}

          <li>
            <Link
              to="/admin/users"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-people"></i>
              <span>Customers</span>
            </Link>
          </li>

          {/* Contact */}

          <li>
            <Link
              to="/admin/contactmsg"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-chat-left-text"></i>
              <span>Contact Messages</span>
            </Link>
          </li>

          {/* Profile */}

          <li>
            <Link
              to="/admin/profile"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-person-circle"></i>
              <span>Admin Profile</span>
            </Link>
          </li>

          {/* Logout */}

          <li>
            <Link
              to="/admin/logout"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-box-arrow-right"></i>
              <span>Logout</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
